import { useEffect, useState } from 'react';
import { useAuditStore, type TimelineFilters } from '../../store/auditStore';
import { AuditFilterBar } from '../../components/admin/AuditFilterBar';
import { AuditChangeRow } from '../../components/admin/AuditChangeRow';

export function AuditTimelineSubTab() {
  const {
    timeline,
    timelineCursor,
    timelineLoading,
    timelineError,
    fetchTimeline,
    loadMoreTimeline,
  } = useAuditStore();
  const [draft, setDraft] = useState<TimelineFilters>({});

  useEffect(() => {
    fetchTimeline({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (timelineError) {
    return (
      <div className="rounded-md border border-red-200 dark:border-red-800 bg-red-50 dark:bg-red-900/20 p-4 text-sm text-red-700 dark:text-red-300">
        <div>{timelineError}</div>
        <button className="mt-2 text-xs underline" onClick={() => fetchTimeline()}>
          Retry
        </button>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3">
      <AuditFilterBar
        filters={draft}
        onChange={setDraft}
        onSubmit={() => fetchTimeline(draft)}
      />
      <div className="rounded-md border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800">
        <div className="grid grid-cols-12 gap-2 px-3 py-2 bg-gray-50 dark:bg-gray-700/50 text-xs uppercase text-gray-500 dark:text-gray-400">
          <div className="col-span-2">Time</div>
          <div className="col-span-2">Source</div>
          <div className="col-span-3">Entity</div>
          <div className="col-span-1">Field</div>
          <div className="col-span-4">Old → New</div>
        </div>
        {timeline.length === 0 && !timelineLoading ? (
          <div className="p-6 text-center text-sm text-gray-400 dark:text-gray-500">No changes in this window.</div>
        ) : (
          timeline.map((c) => <AuditChangeRow key={c.id} change={c} />)
        )}
      </div>
      {timelineCursor && (
        <button
          className="self-center text-xs text-blue-600 dark:text-blue-400 underline disabled:opacity-50"
          onClick={loadMoreTimeline}
          disabled={timelineLoading}
        >
          {timelineLoading ? 'Loading…' : 'Load more'}
        </button>
      )}
    </div>
  );
}
